import { ICreateProductForm } from '../AddProductPage/types';

export interface IUpdateProductForm extends ICreateProductForm {
  id: number;
  isVerified: boolean;
}

export const UpdateProductDefaultValues = {
  launchDate: null,
  closeDate: null,
};
